export default __webpack_public_path__ + "static/media/lato-regular.56654d0d.eot";